import type { FC } from "react";
import React, { useMemo } from "react";
import { useTracking, useTranslation } from "@edreamsodigeo/frontend-core";
import { Button } from "@edreamsodigeo/prisma-design-system";

import { PRIME_LANDING_PAGE_URL } from "./config/constants";
import type { HeaderPrimeButtonProps } from "./config/contracts";

const HeaderPrimeButton: FC<HeaderPrimeButtonProps> = ({
  hoverButton,
  fullWidth = true,
  pageCategoryName,
  isPrimeLoggedUser,
}) => {
  const { t } = useTranslation();
  const { trackEvent } = useTracking();

  const openPrimeLandingPage = (): void => {
    trackEvent({
      label:
        "prime_header_click_p:" +
        isPrimeLoggedUser +
        "_pag:" +
        pageCategoryName,
      category: pageCategoryName,
      action: "header_prime",
    });
    const { protocol, host } = window.location;
    window.open(`${protocol}//${host}/${PRIME_LANDING_PAGE_URL}`, "_blank");
  };

  useMemo(() => {
    if (pageCategoryName) {
      trackEvent({
        label:
          "prime_header_load_p:" +
          isPrimeLoggedUser +
          "_pag:" +
          pageCategoryName,
        category: pageCategoryName,
        action: "header_prime",
      });
    }
    //TODO: to be fixed by OPTIMUS
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageCategoryName]);

  return (
    <Button
      type={"secondary"}
      size={"small"}
      onClick={openPrimeLandingPage}
      onMouseOver={hoverButton}
      fullWidth={fullWidth}
    >
      {t("visibility.header.main.button")}
    </Button>
  );
};

export default HeaderPrimeButton;
